import axios from 'lib/axios'
import { normalizeMetricStatus } from 'lib/metricStatus'
import { CompatibleProduct, MetricDataResponse, QueryMetricLatestValueRequest } from 'models'

const basePath = '/api/v4/metrics'

export const MetricsServiceV4 = {
  getLatest: async (metricSlug: string, request: QueryMetricLatestValueRequest = {}) => {
    const res = await axios.post<MetricDataResponse>(`${basePath}/${metricSlug}/latest`, {
      metric_request: { instance_names: [], ...request }
    })
    if (res.data) {
      res.data.status = normalizeMetricStatus(res.data.status)
    }
    return res
  },

  getCompatibleProducts: async (metricSlug: string): Promise<CompatibleProduct[]> => {
    const { data } = await axios.post<CompatibleProduct[]>(`${basePath}/${metricSlug}/compatible-products`)
    return data
  }
}
